import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { AppNewsletter } from '../../../layouts/client/components/app-newsletter/app-newsletter';

@Component({
  selector: 'app-join-section',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    TranslatePipe,
    AppNewsletter
  ],
  templateUrl: './join-section.html',
  styleUrl: './join-section.scss'
})
export class JoinSection {}
